import FeatureGate from "@/src/components/feature-gate";
import FeatureRequestsScreen from "@/src/screens/feature-requests/feature-requests-screen";

export default function FeatureRequests() {
  return (
    <FeatureGate feature="featureRequests">
      <FeatureRequestsScreen />
    </FeatureGate>
  );
}
